var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon11(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.556,
    height: 33.416,
    viewBox: "0 0 34.556 33.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1665",
    "data-name": "Rectangle 1665",
    width: 34.556,
    height: 33.415,
    fill: "#ff9ee0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4660",
    "data-name": "Group 4660",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4659",
    "data-name": "Group 4659",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14059",
    "data-name": "Path 14059",
    d: "M5.418,21.731l-.873,5.121a5.6,5.6,0,0,0,8.125,5.914l4.607-2.421,4.607,2.421a5.6,5.6,0,0,0,8.125-5.914l-.873-5.121L32.856,18.1A5.6,5.6,0,0,0,29.75,8.54L24.6,7.793,22.309,3.131a5.608,5.608,0,0,0-10.063,0L9.952,7.793,4.805,8.54A5.6,5.6,0,0,0,1.7,18.1ZM3.564,13.417A2.108,2.108,0,0,1,5.3,11.959l6.047-.88a1.721,1.721,0,0,0,1.295-.947L15.352,4.66a2.142,2.142,0,0,1,3.852,0l2.709,5.471a1.721,1.721,0,0,0,1.295.947l6.047.88a2.143,2.143,0,0,1,1.189,3.663l-4.375,4.266a1.731,1.731,0,0,0-.493,1.53l1.034,6.02A2.15,2.15,0,0,1,23.486,29.7L18.08,26.861a1.721,1.721,0,0,0-1.6,0L11.069,29.7a2.15,2.15,0,0,1-3.124-2.267l1.034-6.02a1.731,1.731,0,0,0-.493-1.53L4.112,15.622a2.1,2.1,0,0,1-.548-2.2",
    transform: "translate(0 0.001)",
    fill: "#ff9ee0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon11);
export default __webpack_public_path__ + "static/media/media_icon11.03b728c49f2296e52b35370c307f24c4.svg";
export { ForwardRef as ReactComponent };